import { render, staticRenderFns } from "./PracticeSelector.vue?vue&type=template&id=2d0e3d5a"
import script from "./PracticeSelector.vue?vue&type=script&lang=js"
export * from "./PracticeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports